import { render, staticRenderFns } from "./NewUi.vue?vue&type=template&id=1337a988&"
import script from "./NewUi.vue?vue&type=script&lang=js&"
export * from "./NewUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports